var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulpal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 105,
    fill: "#10CAD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 87.6H294.4C328.532 87.6 409.6 113.2 409.6 220.159C409.6 318 329.171 352.717 294.4 352.717H187.734L115.2 433.2V272.235H277.333C277.333 272.235 324.266 271.762 324.266 220.159C324.266 168.556 277.333 168.083 277.333 168.083H115.2V87.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.544 260.607H101.4V179.891H279.544C286.846 179.891 313.843 186.809 313.843 220.247C313.827 253.458 289.05 260.607 279.544 260.607ZM108.039 253.685H279.544C279.765 253.685 307.204 253.224 307.204 220.247C307.204 188.192 279.765 186.809 279.544 186.809H108.039V253.685Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.428 234.089C285.151 234.089 290.601 228.41 290.601 221.404C290.601 214.398 285.151 208.719 278.428 208.719C271.706 208.719 266.256 214.398 266.256 221.404C266.256 228.41 271.706 234.089 278.428 234.089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulpal);
export default __webpack_public_path__ + "static/media/pulpal.24cf12287ac091c7892ac6c3c1c1800e.svg";
export { ForwardRef as ReactComponent };